/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// MENU > INDICATOR
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	dropdownindicator: {
		width:'100%',
		height:'100%',
		background: theme.color.light.light.swatch,
		borderRadius: pxToEm(5),
		display: 'flex',
		justifyContent: 'space-between',
		alignItems:'center',
		boxShadow: theme.boxShadow.small,
		cursor: 'pointer',
        border: `${pxToEm(2)} solid transparent`,
        transition: 'border .2s linear 0s',
        '&:hover':{
			borderColor: theme.color.secondary.light.swatch
		},
		'&.active-true':{
			borderColor: theme.color.primary.medium.swatch
		},
		'& .name-iconTitle':{
			display: 'flex',
			justifyContent: 'space-between',
			alignItems:'center',
		},
		'& .icon':{
			fontSize:pxToEm(16),
			padding: `${pxToEm(20)} ${pxToEm(15)}`,
			color: theme.color.neutral.medium.swatch
		},
		'& .name-nameTitle':{
			padding: `${pxToEm(9)} 0`,
			'& .name':{
				fontSize:pxToEm(14),
				height: pxToEm(16),
				color: theme.color.neutral.medium.swatch,
                fontWeight: 600,
			},
			'& .title':{
				fontSize:pxToEm(18),
                fontWeight: 500,
				color: theme.color.supporting.dark.swatch
			},
			'& .selected':{
				color: theme.color.primary.medium.swatch
			}
		},
		'& .name-sort-down':{
			padding: `0 ${pxToEm(17)}`,
			color: theme.color.supporting.dark.swatch
		}
	}
});